import { CONFIRM_LEAD_MS } from './constants';

/** Last instant a booking of `startsAt` still reaches the endpoint as a future callback. */
export const confirmDeadlineOf = (startsAt: string) => Date.parse(startsAt) - CONFIRM_LEAD_MS;

/** Time the visitor has left to confirm `startsAt`; negative once the deadline is behind them. */
export const msLeftToConfirm = (startsAt: string, now: Date) =>
  confirmDeadlineOf(startsAt) - now.getTime();

/**
 * Whether a call back at `instant` can still be booked. The endpoint rejects an instant that is
 * no longer in the future, so the last `CONFIRM_LEAD_MS` before it are already too late.
 */
export const canStillBeConfirmed = (instant: number, now: Date) =>
  instant - CONFIRM_LEAD_MS > now.getTime();

const pad = (value: number) => String(value).padStart(2, '0');

/** `m:ss`, gaining an `h:` only while there is more than an hour to go. Never counts below zero. */
export function formatCountdown(remainingMs: number): string {
  const seconds = Math.max(0, Math.floor(remainingMs / 1000));
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor(seconds / 60) % 60;

  return hours > 0
    ? `${hours}:${pad(minutes)}:${pad(seconds % 60)}`
    : `${minutes}:${pad(seconds % 60)}`;
}
